<template>
  <div class="paymentHistory" id="payment-history">
    <div class="header paymentHistory__columns">
      <p class="header__column left">お支払い日</p>
      <p class="header__column center">お支払い内容</p>
      <p class="header__column right">金額</p>
    </div>
    <div class="history paymentHistory__columns" v-for="(purchase, index) in dispPurchaseList[nowIndex]" :key="index" @click="move(history)">
      <p class="history__column__left left">{{ purchase.datetime.format('YYYY/MM/DD') }}</p>
      <p class="history__column__center center">{{ purchase.transactionDetails.description }}</p>
      <div class="history__column__right right">{{ purchase.price }}円</div>
    </div>
    <div class="paging" v-if="dispPurchaseList.length > 1">
      <button class="paging__page__arrow" :disabled="nowIndex <= 0" @click="pageChanege(nowIndex - 1)">&lt;</button>
      <button class="paging__page" v-for="i in dispPurchaseList.length" :key="i" @click="pageChanege(i - 1)" :disabled="nowIndex == i - 1">{{ i }}</button>
      <button class="paging__page__arrow" :disabled="nowIndex + 1 >= dispPurchaseList.length" @click="pageChanege(nowIndex + 1)">&gt;</button>
    </div>
  </div>
</template>

<script>
const MAX_ROW = 10;

export default {
  name: 'PaymentHistory',
  data() {
    return {
      purchaseList: [],
      dispPurchaseList: [],
      nowIndex: 0,
      user: null
    };
  },
  async created() {
    await this.load();
  },
  methods: {
    async load() {
      await this.$store.dispatch('payment/loadPurchaseHistory', this.$store.state.auth.uid);
      this.purchaseList = this.$store.getters['payment/paymentHistory'];
      let result = [];
      var i = 0;
      for (i = 0; i < this.purchaseList.length; i = i + MAX_ROW) {
        result.push(this.purchaseList.slice(i, i + MAX_ROW));
      }

      this.dispPurchaseList = result;
      this.nowIndex = 0;
    },
    pageChanege(idx) {
      this.nowIndex = idx;
    },
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/payment-history.scss';
</style>
